<template>
  <div class="about-container">
    <!-- About Section -->
    <section class="about-section">
      <div class="about-content">
        <p class="about-description">
          <i>
            Travvir (short for ‘Travel Virtually’) is an AI image research and
            development company. Our advanced machine learning models transform
            real-world environments into immersive digital replicas using data
            captured directly from smartphones, making it easy and engaging for
            anyone to create and explore places digitally.
          </i>
        </p>
      </div>
    </section>

    <!-- Executives Section -->
    <section class="executives-section">
      <h2 class="section-title"><i>Executives</i></h2>

      <div class="executives-grid">
        <div
          class="executive-profile"
          v-for="(executive, index) in ExecutivesArr"
          :key="index"
        >
          <a
            :class="`executive-name ${executive.linkedin ? 'share' : ''}`"
            target="_blank"
            :href="executive.linkedin"
            >{{ executive.name }}</a
          >
          <p class="executive-title">
            <i>{{ executive.title }}</i>
          </p>
        </div>
      </div>
    </section>

    <!-- Research & Engineering Section -->
    <section class="research-section">
      <h2 class="section-title"><i>Research & Engineering</i></h2>

      <div class="research-grid">
        <div class="researcher-profile" v-for="i in TeamArr">
          <a
            :class="`researcher-name ${i.linkedin ? 'share' : ''}`"
            :href="i.linkedin"
            target="_blank"
            >{{ i.name }}</a
          >
          <p class="researcher-title">
            <i>{{ i.title }}</i>
          </p>
        </div>
      </div>
    </section>

    <!-- Evangelists Section -->
    <section class="evangelists-section">
      <h2 class="section-title"><i>Evangelists</i></h2>

      <div class="evangelists-grid">
        <div class="evangelist-profile" v-for="sale in SalesArr">
          <a
            :class="`evangelist-name ${sale.linkedin ? 'share' : ''}`"
            :href="sale.linkedin"
            target="_blank"
            >{{ sale.name }}</a
          >
          <p class="evangelist-title">
            <i>{{ sale.title }}</i>
          </p>
        </div>
      </div>
    </section>

    <!-- Finance & Legal Section -->
    <section class="finance-section">
      <h2 class="section-title"><i>Finance & Legal</i></h2>

      <div class="finance-grid">
        <div class="finance-profile" v-for="legal in LegalArr">
          <a
            :class="`finance-name ${legal.linkedin ? 'share' : ''}`"
            :href="legal.linkedin"
            target="_blank"
            >{{ legal.name }}</a
          >
          <p class="finance-title">
            <i>{{ legal.title }}</i>
          </p>
        </div>
      </div>
    </section>

    <!-- Strategic Leadership Section -->
    <section class="advisors-section">
      <h2 class="section-title"><i>Board & Advisors</i></h2>

      <div class="advisors-grid">
        <div
          class="advisor-profile"
          v-for="advisor in AdvisorArr"
          :key="advisor.name"
        >
          <a
            :class="`advisor-name ${advisor.linkedin ? 'share' : ''}`"
            :href="advisor.linkedin"
            target="_blank"
            >{{ advisor.name }}</a
          >
          <p class="advisor-title">
            <i>{{ advisor.title }}</i>
          </p>
          <p class="advisor-company">
            <i>{{ advisor.Education }}</i>
          </p>
          <p class="advisor-company">
            <i>{{ advisor.company1 }}</i>
          </p>
          <p class="advisor-company">
            <i>{{ advisor.company2 }}</i>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
//seo meta tags
const config = useRuntimeConfig();
const SalesArr = [
  {
    name: "Rupesh Mishra",
    title: "Marketing Evangelist - Dubai & Middle East",
    linkedin: "https://www.linkedin.com/in/mishrarupesh/",
  },
  {
    name: "Ashish Semwal",
    linkedin: "https://www.linkedin.com/in/ashish-semwal-a6552513/",
    title: "Business Evangelist, Strategic Partnerships",
  },
  {
    name: "Bedrock Ventures",
    title: "Strategic Partner",
    linkedin: "https://www.linkedin.com/in/vivek-bihani-3033533/",
  },
];

const ExecutivesArr = [
  {
    name: "Rohan Mital",
    title: "Co-founder & CEO",
    linkedin: "https://www.linkedin.com/in/rohan-mital-7a05b8145/",
  },
  {
    name: "Rupesh Pandey",
    title: "Co-founder & CTO",
    linkedin: "https://www.linkedin.com/in/rupesh-pandey-424b8754/",
  },
];
const TeamArr = [
  {
    name: "Sumanyu",
    title: "ML Head, AI Research Specialist",
    linkedin: "https://www.linkedin.com/in/sumanyu-asthana/",
  },
  {
    name: "Priyam",
    title: "Lead Developer, Software Engineering",
    linkedin: "https://www.linkedin.com/in/priyamharsh14/",
  },
  {
    name: "Gourav",
    linkedin: "https://www.linkedin.com/in/gourav-kumar-19111b279/",
    title: "Frontend Developer, UI/UX Engineering",
  },
  {
    name: "Ajay",
    title: "Backend Engineer",
  },
  {
    name: "Shubham",
    title: "Frontend Developer",
  },
  {
    name: "Yash",
    title: "Frontend Developer",
  },
  {
    name: "Madhav",
    title: "AI Research, Machine Learning",
  },
  {
    name: "Pratima",
    title: "QA Engineer, Testing Automation",
  },
  {
    name: "Utkarsh",
    title: "Backend Developer",
  },
  {
    name: "Aditya",
    title: "Backend Developer",
  },
  {
    name: "Priyani",
    title: "Backend Developer",
  },
];

const LegalArr = [
  {
    name: "Lalit Arora",
    title: "Head of Finance, Financial Operations",
    linkedin: "https://www.linkedin.com/in/lalit-arora-619b0214/",
  },
  {
    name: "Ravish Kumar",
    title: "Auditor & CA",
  },
  {
    name: "Sigma Chambers",
    title: "Legal Advisors",
  },
  {
    name: "Sanchita Saumya",
    title: "Compliance & Filing Officer",
  },
];
const AdvisorArr = [
  {
    name: "Sanjiv Mital",
    Education: "IIT Kanpur IIM Calcutta",
    title: "Board Member",
    linkedin: "https://www.linkedin.com/in/sanjiv-mital-650214/",
    company1: "Ex. Vice Chairman Bharti Telesoft",
    company2: "Ex. CEO NISG",
  },
  {
    name: "Ranjit Singh",
    linkedin: "https://www.linkedin.com/in/ranjit-singh-67016470/",
    title: "Board Member",
    Education: "BITS Pilani IIM Ahmedabad",
    company1: "Global COO - Polyplex",
    company2: "Ex. MD - Kalpataru",
  },
  {
    name: "Yash Gupta",
    linkedin: "https://www.linkedin.com/in/yash-gupta-ygrellp/",
    title: "Mentor",
    Education: "Harvard Business School",
    company1: "Ex. MD - Hines",
    company2: "Ex. CEO - Silverglades",
  },
  {
    name: "Arvind Jha",
    linkedin: "https://www.linkedin.com/in/jalajboy/",
    title: "Advisor",
    Education: "IIT Kharagpur",
    company1: "Ex. Director - LAVA International",
    company2: "Ex. Director - Adobe Engineering",
  },
];

useSeoMeta({
  title: "About Us | Travvir",
  description:
    "Travvir is an AI research and development company. Our advanced spatial intelligence models transform real-world environments into immersive digital replicas using data captured directly from smartphones.",
  image: config.public.NUXT_CDN_URL + "/static/website/bg/bg-2.jpg",
  keywords:
    "AI research, spatial intelligence, digital replicas, machine learning models, 360 view, virtual tour, 3D tour, immersive technology",
  ogTitle: "About Travvir - Spatial AI Innovation",
  ogDescription: "Discover our story in spatial AI and digital exploration",
  ogUrl: "https://travvir.com/about",
  twitterCard: "summary_large_image",
  twitterTitle: "About Travvir - Spatial AI Innovation",
  twitterDescription: "Learn about our spatial AI research and innovation",
});
</script>

<style lang="scss" scoped>
@import "~/assets/styles/variables";
@import "~/assets/styles/mixins";

.about-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  background: #000;
  color: #fff;
  // min-height: 100svh;
  height: fit-content;

  @include respond-below(md) {
    padding: 3rem 1.5rem;
  }

  @include respond-below(sm) {
    padding: 2rem 1rem;
  }
}

.about-section {
  margin-bottom: 4rem;

  .about-icon {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .about-title {
    font-size: clamp(2.5rem, 5vw, 4rem);
    font-weight: 600;
    margin-bottom: 2rem;
    color: #00d4aa;
    letter-spacing: -0.02em;
  }

  .about-content {
    max-width: 800px;

    p {
      font-size: 1.126rem;
      line-height: 1.7;
      margin-bottom: 1.5rem;
      color: #8c8a8a;

      @include respond-below(sm) {
        font-size: 1rem;
        line-height: 1.6;
      }
    }

    .about-description {
      font-size: 1.15rem;
      color: #999;
      margin-bottom: 0.2rem;
      font-style: italic;

      @include respond-below(sm) {
        font-size: 1.125rem;
      }
    }
  }
}

.executives-section,
.research-section,
.evangelists-section,
.finance-section,
.advisors-section {
  margin-bottom: 6rem;

  .section-title {
    font-size: clamp(2rem, 3vw, 2.5rem);
    font-weight: 500;
    font-style: italic;
    margin-bottom: 1.5rem;
    // background: radial-gradient(
    //   82.09% 97.37% at 18.69% 2.63%,
    //   #5d5be6 18.01%,
    //   #fff 82.09%
    // );
    background-image: linear-gradient(
      90deg,
      #fff 1.51%,
      #5d5be6 18.01%,
      #fff 82.09%
    );

    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;

    letter-spacing: -0.01em;
  }
}

.executives-grid,
.research-grid,
.evangelists-grid,
.finance-grid,
.advisors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem 5rem;

  @include respond-below(lg) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 3.5rem 4rem;
  }

  @include respond-below(md) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  @include respond-below(sm) {
    gap: 2.2rem;
  }
}

.executive-profile,
.researcher-profile,
.evangelist-profile,
.finance-profile,
.advisor-profile {
  .executive-name,
  .researcher-name,
  .evangelist-name,
  .finance-name,
  .advisor-name {
    text-decoration: none;
    font-size: 1.4rem;
    font-weight: 500;
    margin-bottom: 0.15rem;
    color: #ffffff;
  }
  .executive-title,
  .executive-company,
  .researcher-title,
  .researcher-company,
  .evangelist-title,
  .evangelist-company,
  .finance-title,
  .finance-company,
  .advisor-title,
  .advisor-company {
    font-size: 1rem;
    color: #999;
    margin-bottom: 0.2rem;
    font-style: italic;
    line-height: 1.3;

    @include respond-below(sm) {
      font-size: 0.95rem;
    }
  }
}

// Responsive adjustments
@include respond-below(sm) {
  .about-section {
    margin-bottom: 4rem;
  }

  .executives-section,
  .research-section,
  .evangelists-section,
  .finance-section,
  .advisors-section {
    margin-bottom: 4rem;

    .section-title {
      margin-bottom: 2.5rem;
    }
  }
}
.share {
  cursor: pointer;
}
</style>
